import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from 'react';
import { shape } from 'prop-types';
import CouponCard from '@magalu/stereo-ui/organisms/CouponCard';
import { CouponCodeCopy } from '@magalu/stereo-ui/molecules';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { findProductWithCoupon, formattedDate, getCouponInfo, isValidDate } from './utils';
var SelectionCouponCard = function SelectionCouponCard(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var title = staticProps.title,
    products = staticProps.products,
    endDate = staticProps.endDate,
    type = staticProps.type;
  var isCouponType = type === 'coupon';
  var productWithCoupon = findProductWithCoupon(products);
  var isValidEndDate = isValidDate(endDate);
  if (!productWithCoupon || !isValidEndDate || !isCouponType) return null;
  var _ref2 = getCouponInfo(productWithCoupon) || {},
    code = _ref2.code,
    discountType = _ref2.discountType,
    discountValue = _ref2.discountValue;
  var handleView = function handleView() {
    publish('coupon:viewItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: title
    });
  };
  var handleClick = function handleClick() {
    publish('coupon:selectItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: title
    });
  };
  useEffect(function () {
    handleView();
  }, []);
  return React.createElement(CouponCard, _extends({
    headerText: title
  }, staticProps), React.createElement(CouponCodeCopy, {
    code: code.toUpperCase(),
    discountType: discountType,
    discountValue: discountValue,
    expirationDate: formattedDate(isValidEndDate == null ? void 0 : isValidEndDate.parsedDate),
    auxiliaryText: "Copie o cupom e cole na revis\xE3o. V\xE1lido at\xE9",
    onCopySuccess: handleClick
  }));
};
process.env.NODE_ENV !== "production" ? SelectionCouponCard.propTypes = {
  "static": shape({}),
  structure: shape({})
} : void 0;
SelectionCouponCard.defaultProps = {
  "static": {},
  structure: {}
};
SelectionCouponCard.ssr = false;
SelectionCouponCard.displayName = 'SelectionCouponCard';
export default withLayoutProps(SelectionCouponCard);